import React from 'react';

const MockCalendarIntegration: React.FC = () => {
  return (
    <div className="p-4 bg-white">
      <h2 className="text-lg font-bold text-gray-900 mb-2">Calendar Integration</h2>
      <p className="text-sm text-gray-600 mb-4">
        Subscribe to your reservations in external calendar apps.
      </p>

      {/* iCal Feed URL */}
      <div className="mb-4">
        <label className="block text-xs font-medium text-gray-700 mb-2">
          Your iCal Feed URL
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            className="flex-1 px-3 py-2 text-xs border border-gray-300 rounded-lg bg-gray-50 font-mono"
            value="https://app.example.com/api/calendar/feed/abc123.ics"
            readOnly
          />
          <button className="px-3 py-2 text-xs bg-blue-600 text-white rounded-lg whitespace-nowrap">
            Copy
          </button>
        </div>
      </div>

      {/* Calendar Apps */}
      <div className="space-y-3">
        <p className="text-xs font-medium text-gray-700">Add to your calendar:</p>

        {/* Google Calendar */}
        <button className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
          <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-red-600" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm-9 15h-3v-9h3v9zm6 0h-3V9h3v9z" />
            </svg>
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-gray-900">Google Calendar</p>
            <p className="text-xs text-gray-500">Add subscription to Google Calendar</p>
          </div>
        </button>

        {/* Apple Calendar */}
        <button className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-gray-900">Apple Calendar</p>
            <p className="text-xs text-gray-500">Open in Calendar app on Mac/iPhone</p>
          </div>
        </button>

        {/* Outlook */}
        <button className="w-full flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M21 5H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V6a1 1 0 00-1-1zm-1 12H4V8h16v9z" />
            </svg>
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-gray-900">Outlook</p>
            <p className="text-xs text-gray-500">Add to Microsoft Outlook calendar</p>
          </div>
        </button>
      </div>

      {/* Regenerate Token */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <button className="text-xs text-red-600 hover:text-red-700">
          Regenerate feed URL (invalidates old URL)
        </button>
      </div>
    </div>
  );
};

export default MockCalendarIntegration;
